// extracted by mini-css-extract-plugin
export var banner = "_eu-0";
export var closeButton = "_eu-2";
export var greenCheckmark = "_eu-3";
export var hereLink = "_eu-4";
export var titleIcon = "_eu-1";